import thunk from 'redux-thunk';
import {
  createStore as reduxCreateStore,
  compose,
  applyMiddleware,
} from 'redux';
import rootReducer, { StateType } from '../reducers';
import { analytics } from '../middlewares/analytics';
import { exposeOriginalQueryKey } from '../middlewares/exposeOriginalQueryKey';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { isClientSide } from '../../utils/ssrUtils';

const middlewares = [
  exposeOriginalQueryKey,
  thunk,
  analytics(doctrineAnalytics),
];

const injectDevtool = () => {
  /* eslint-disable */
  if (process.env.NODE_ENV === 'test') return compose;

  if (isClientSide && window.__REDUX_DEVTOOLS_EXTENSION__) {
    return window.__REDUX_DEVTOOLS_EXTENSION__();
  }

  return compose;
  /* eslint-enable */
};

if (isClientSide && window.LogRocket)
  middlewares.push(window.LogRocket.reduxMiddleware());

const enhancer = compose(applyMiddleware(...middlewares), injectDevtool());

export function createStore(initialState: Partial<StateType>) {
  const store = reduxCreateStore(rootReducer, initialState, enhancer);
  return store;
}
